import axios from "../axios";
import { GiftListResponse } from "../../types";
import { AxiosReturn } from "../types";
import * as Requests from "../requests";

export const getGiftGroupsApi = (
  token: string,
  pos_entity_id?: string
): AxiosReturn<GiftListResponse> => {
  return axios.get(Requests.giftGroupsURL, {
    headers: {
      token,
    },
    params: {
      pos_entity_id,
      ...(pos_entity_id ? { include_pos_entity_id: 1 } : {}),
    },
  });
};
